module.exports = __webpack_public_path__ + "static/media/loading_animation.4c20b8c4.svg";